// Única fuente de longitudes y rangos de captura: un mismo dato tiene el mismo límite en todas
// las pantallas (personal e invitado). Cada límite es lógico para el dato y nunca mayor que su
// columna en la base; el backend (util/FieldLimits.java) rechaza solo lo que no cabe en la base.
export const FIELD_LIMITS = {
  // Empresa / sucursal (límite de captura, siempre menor o igual a la columna de la base)
  businessName: 80,
  legalName: 90,
  branchName: 80,
  rfc: 13,
  personName: 40,
  contactTitle: 5,
  email: 80,
  phone: 10,
  legalRepresentative: 80,
  insuranceCompany: 60,
  insurancePolicyNumber: 30,
  street: 80,
  exteriorNumber: 4,
  interiorNumber: 4,
  neighborhood: 60,
  municipality: 50,
  locality: 50,
  country: 30,
  postalCode: 5,
  geolocation: 40,
  betweenStreets: 80,
  reference: 80,
  mainActivities: 500,
  // Inmueble (números)
  employeesCount: { min: 1, max: 1000, digits: 4 },
  constructionArea: { min: 10, max: 10000, digits: 8 },
  landArea: { min: 10, max: 10000, digits: 8 },
  constructionLevels: { min: 1, max: 10, digits: 2 },
  floatingPopulation: { min: 0, max: 99999, digits: 5 },
  maximumCapacity: { min: 0, max: 99999, digits: 5 },
  // Inspección / UIPC
  inspectorContact: 255,
  ppeDetails: 500,
  uipcWorkerName: 255,
  uipcPosition: 150,
  uipcAllergies: 500,
  curp: 18,
  // Cotización
  quotationComments: 255,
  additionalServiceDescription: 150,
  additionalServiceNotes: 300,
  maxPrice: 10000000,
  maxQuantity: 1000000,
};
